import request from '@host-panel/request';

import { FindUserByNameResponse } from './usersTypes';

let controller: AbortController;

export function findUserByNameRequest(
  username: string,
  count = 15
): Promise<FindUserByNameResponse> {
  // @ts-ignore
  controller?.abort('findUserByNameRequest: Abort previous request');
  controller = new AbortController();

  return request(`/host-panel/find-user/name`, {
    signal: controller.signal,
    data: {
      name: encodeURIComponent(username),
      count
    }
  });
}
